(() => {
  if(window.__amJournalMotion20261101)return;
  window.__amJournalMotion20261101=true;
  const scope='.am-journal,.journal-index,.journal-story,.am-collab-banner,.am-collect';
  const targets=[...document.querySelectorAll('[data-reveal]')].filter(node=>node.closest(scope));
  if(!targets.length)return;
  targets.forEach(node=>node.setAttribute('data-reveal-repeat',''));
  const reduced=window.matchMedia('(prefers-reduced-motion:reduce)');
  if(reduced.matches||!('IntersectionObserver'in window))return;
  let direction='down';
  const scrollRoot=targets[0].closest('.page-wrapper');
  const offset=()=>Math.max(0,window.scrollY||document.scrollingElement?.scrollTop||scrollRoot?.scrollTop||0);
  let previous=offset();
  const track=()=>{
    const current=offset(),difference=current-previous;
    if(difference>0)direction='down';
    else if(difference<0){
      if(direction!=='up')targets.forEach(node=>{
        if(node.classList.contains('is-visible'))node.setAttribute('data-reveal-static','');
      });
      direction='up';
    }
    previous=current;
  };
  document.documentElement.classList.add('motion-ready');
  window.addEventListener('scroll',track,{passive:true,capture:true});
  const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{
    const node=entry.target;
    if(entry.isIntersecting){
      node.toggleAttribute('data-reveal-static',direction==='up');
      node.classList.add('is-visible');
    }else{
      node.classList.remove('is-visible');
      node.removeAttribute('data-reveal-static');
    }
  }),{threshold:.1});
  targets.forEach(node=>observer.observe(node));
  reduced.addEventListener('change',()=>{
    if(!reduced.matches)return;
    document.documentElement.classList.remove('motion-ready');
    observer.disconnect();
    window.removeEventListener('scroll',track,true);
  });
})();
